import { MicroSiteStartPage } from 'components/MicroSite/StartPage';

const ScreenMicroSiteStartPage = () => <MicroSiteStartPage />;

export default ScreenMicroSiteStartPage;
